<div class="lib-shell">
  <div class="container">

    <!-- ── HEADER ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Liberações Pendentes</h1>
        <p>Orçamentos aguardando aprovação do gestor</p>
      </div>
      <span class="badge-contador" *ngIf="itens.length > 0">{{ itens.length }} pendente{{ itens.length > 1 ? 's' : '' }}</span>
      <button type="button" class="btn-atualizar" (click)="carregar()" [disabled]="carregando"><app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"/>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
        </svg>
        {{ carregando ? 'Atualizando...' : 'Atualizar' }}
      </button>
    </div>

    <!-- ── LOADING ── -->
    <div class="loading-indicator-row" *ngIf="carregando">
      <app-loading-indicator></app-loading-indicator>
    </div>

    <!-- ── ERRO ── -->
    <div class="erro-box" *ngIf="erro">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
      {{ erro }}
    </div>

    <!-- ── VAZIO ── -->
    <div class="vazio-box" *ngIf="!carregando && !erro && itens.length === 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.3">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
      <p>Nenhuma liberação pendente no momento.</p>
      <span>A lista atualiza automaticamente a cada 10 segundos.</span>
    </div>

    <!-- ── LISTA DE LIBERAÇÕES ── -->
    <div class="lib-lista" *ngIf="!carregando || itens.length > 0">
      <div class="lib-card" *ngFor="let item of itens">

        <!-- Cabeçalho do card -->
        <div class="lib-card-header">
          <!-- Linha 1: nunota + valor + seta (visível no mobile como faixa separada) -->
          <div class="lib-card-top-row">
            <div class="lib-card-nunota">
              <span class="nunota-label">#{{ item.nunota }}</span>
              <span class="badge-orcamento">Orçamento</span>
            </div>
            <div class="lib-card-valor">R$ {{ fmtBrl(item.vlrnota) }}</div>
            <div class="lib-card-expand">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                [style.transform]="item.expandido ? 'rotate(180deg)' : 'rotate(0deg)'"
                style="transition: transform 0.2s">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </div>
          <!-- Cliente + CNPJ -->
          <div class="lib-card-info">
            <span class="info-cliente" [title]="item.cliente">{{ item.cliente }}</span>
            <span class="info-sep">·</span>
            <span class="info-doc">{{ fmtDoc(item.docparc) }}</span>
            <span class="info-sep">·</span>
            <span class="info-doc">{{ fmtDoc(item.evento) }}</span>
          </div>
          <!-- Meta: data / vendedor / aeronave -->
          <div class="lib-card-meta">
            <span class="meta-data">{{ item.dtmov }}</span>
            <span class="meta-sep">|</span>
            <span class="meta-vend">{{ item.vendedor }}</span>
            <span class="meta-sep" *ngIf="item.aeronave">|</span>
            <span class="meta-aero" *ngIf="item.aeronave">✈ {{ item.aeronave }}</span>
          </div>
        </div>

        <!-- Uma linha por evento de liberação que o usuário pode liberar (cada uma com Aprovar/Reprovar próprios) -->
        <div class="lib-card-razoes">
          <div *ngIf="item.razoes.length === 0" class="razao-item razao-sem">
            ✅ Todos os bloqueios foram liberados pelo Sankhya. Clique em <strong>Aprovar</strong> para converter em Pedido de Venda.
          </div>
          <div class="razao-grupo" *ngFor="let g of item.grupos">
            <div class="razao-item razao-linha">
              <button type="button" class="razao-info" (click)="alternarGrupo(item, g)" [attr.aria-expanded]="g.aberto">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                <span class="razao-texto">{{ g.descricao }}<span class="info-doc" *ngIf="g.evento"> · evento {{ g.evento }}</span></span>
                <span class="razao-qtd" *ngIf="g.razoes.length > 1 || g.razoes[0]?.sequencia">{{ g.razoes.length }} {{ g.razoes.length === 1 ? 'item' : 'itens' }}</span>
                <span class="razao-ver">{{ g.aberto ? 'ocultar' : 'ver itens' }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                    [style.transform]="g.aberto ? 'rotate(180deg)' : 'rotate(0deg)'" style="transition: transform .2s"><polyline points="6 9 12 15 18 9"/></svg>
                </span>
              </button>
              <span class="lib-card-acoes razao-acoes">
                <button type="button" class="btn-reprovar"
                  (click)="abrirModalReprovacao(item.nunota, g.razoes)"
                  [disabled]="aprovando === item.nunota || reprovando === item.nunota">
                  Reprovar
                </button>
                <button type="button" class="btn-aprovar"
                  (click)="aprovar(item.nunota, g.razoes)"
                  [disabled]="aprovando === item.nunota || reprovando === item.nunota">
                  <span *ngIf="aprovando !== item.nunota">Aprovar</span>
                  <app-loading-indicator *ngIf="aprovando === item.nunota" size="inline"></app-loading-indicator>
                </button>
              </span>
            </div>

            <!-- Itens que caíram neste evento -->
            <div class="razao-itens" *ngIf="g.aberto">
              <div class="razao-itens-msg" *ngIf="detalhesItens[item.nunota]?.carregando">Carregando itens...</div>
              <div class="razao-itens-msg" *ngIf="detalhesItens[item.nunota]?.erro">{{ detalhesItens[item.nunota]?.erro }}</div>
              <div class="razao-it" *ngFor="let r of g.razoes">
                <ng-container *ngIf="itemDoGrupo(item.nunota, r) as it; else semDetalhe">
                  <span class="razao-it-seq">{{ r.sequencia }}</span>
                  <span class="razao-it-pn">{{ it.pn || '—' }}</span>
                  <span class="razao-it-desc">{{ it.descricao }}</span>
                  <span class="razao-it-qtd">Qtd {{ it.qtd }}</span>
                </ng-container>
                <ng-template #semDetalhe>
                  <span class="razao-it-seq">{{ r.sequencia || '—' }}</span>
                  <span class="razao-it-desc">{{ r.observacao }}</span>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- Sem bloqueios restantes: aprova a nota inteira -->
        <div class="lib-card-acoes" *ngIf="item.razoes.length === 0">
          <button type="button" class="btn-aprovar" (click)="aprovar(item.nunota)"
            [disabled]="aprovando === item.nunota || reprovando === item.nunota">Aprovar</button>
        </div>

      </div>
    </div>

  </div>
</div>

<!-- ── MODAL REPROVAÇÃO ── -->
<div class="modal-overlay" *ngIf="modalReprovacao !== null" (click)="fecharModalReprovacao()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-titulo">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
      Reprovar Liberação #{{ modalReprovacao }}
    </div>
    <p class="modal-descricao">
      O orçamento permanecerá como <strong>REPROVADO</strong> e o vendedor deverá realizar correções antes de solicitar novamente.
    </p>
    <label class="modal-label">Justificativa *</label>
    <textarea class="modal-textarea" rows="3" placeholder="Descreva o motivo da reprovação..."
      [(ngModel)]="justificativa" maxlength="500"></textarea>
    <div class="modal-acoes">
      <button type="button" class="btn-cancelar-modal" (click)="fecharModalReprovacao()">Cancelar</button>
      <button type="button" class="btn-confirmar-reprovar" (click)="confirmarReprovacao()"
        [disabled]="!justificativa.trim()">
        Confirmar Reprovação
      </button>
    </div>
  </div>
</div>

<!-- ── TOAST ── -->
<div *ngIf="toastVisivel" class="lib-toast">{{ toastMensagem }}</div>
